import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectAdminRoles } from '../../../store/selectors/teammates';
import { isHaveTeammatePermission } from '../../../store/helpers/user';
import { showDialog } from '../../../components/dialog';
import localization from '../../../shared/strings';
import Tag from '../../../components/Tag';

const useTeammatesNavigate = (tab = '') => {
  const user = useSelector((state) => state.user);
  const adminRoles = useSelector(selectAdminRoles);
  const navigate = useNavigate();

  const adminEmails = useMemo(
    () => adminRoles.map((role) => (
      <Tag
        key={role._id}
        type="user"
        avatar={role.avatar}
        text={role.email}
      />
    )),
    [adminRoles],
  );

  const onTeammateNavigateClick = useCallback(() => {
    if (isHaveTeammatePermission('manageTeam', user)) {
      navigate(`/teammates?${tab}`);
      return;
    }

    showDialog({
      title: localization.DIALOGS.TEAM_ACCESS_REQUIRED.title,
      text: localization.DIALOGS.TEAM_ACCESS_REQUIRED.text(adminEmails),
      textBtnCancel: null,
      textBtnOk: localization.DIALOGS.TEAM_ACCESS_REQUIRED.textBtnOk,
    });
  }, [user, adminEmails, navigate, tab]);

  return { adminEmails, onTeammateNavigateClick };
};

export default useTeammatesNavigate;
